import * as React from 'react';
import {Link} from "react-router-dom";
import logo from '../../images/logo.png'
import {isLogged} from "../../utilities/Utilities";

interface Props {
    active: string
}

interface PozycjaMenuProps {
    to: string,
    aktywna: boolean,
    children: React.ReactNode
}

const PozycjaMenu = (props: PozycjaMenuProps) =>
    <li className={'nav-item'}>
        <Link to={props.to} className={props.aktywna ? 'nav-link active' : 'nav-link'}
              aria-current={props.aktywna ? 'page' : undefined}>
            {props.children}
        </Link>
    </li>

export const Header = (props: Props) => {
    const uzytkownik = isLogged() ? JSON.parse(sessionStorage.isUserLoggedMM) : null;

    return <header id={'header'}>
        <nav className="navbar navbar-expand-lg" aria-label={'Menu główne'}>
            <div className={'container'}>
                <Link className="navbar-brand" to={'/'}>
                    <img src={logo} className={'img-fluid'} alt={'Merkury Market – strona główna'}/>
                </Link>
                <button className="navbar-toggler" type="button" data-toggle="collapse"
                        data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                        aria-expanded="false" aria-label="Menu">
                    <span className="navbar-toggler-icon" style={{color: 'black'}}><i className={'fa fa-bars'} aria-hidden={'true'}/></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav ml-auto">
                        <PozycjaMenu to={'/'} aktywna={props.active === 'HOME'}>Strona główna</PozycjaMenu>
                        <PozycjaMenu to={'/instrukcje'} aktywna={props.active === 'INSTRUKCJE'}>Instrukcje</PozycjaMenu>
                        <PozycjaMenu to={'/kartyProfity'} aktywna={props.active === 'KARTY_PROFITY'}>Karty PROFI</PozycjaMenu>
                        <PozycjaMenu to={'/regulamin'} aktywna={props.active === 'STATUTE'}>Regulamin</PozycjaMenu>
                        {uzytkownik ?
                            <PozycjaMenu to={'/konto'} aktywna={props.active === 'USER'}>
                                {uzytkownik.username}
                                <span className={'nav-badge'}>
                                    <span className={'sr-only'}>, rabat do wykorzystania: </span>
                                    {Boolean(uzytkownik.rabatKwota) ? uzytkownik.rabatKwota : 0} PLN
                                </span>
                            </PozycjaMenu>
                            :
                            <>
                                <PozycjaMenu to={'/register'} aktywna={props.active === 'REGISTER'}>Zarejestruj się</PozycjaMenu>
                                <PozycjaMenu to={'/login'} aktywna={props.active === 'LOGIN'}>Zaloguj się</PozycjaMenu>
                            </>
                        }
                    </ul>
                </div>
            </div>
        </nav>
    </header>
}

Header.defaultProps = {}
